import { Module } from 'vuex';
import { IRootState } from '@/store';
import { IItemCommercialTranslationState } from './itemcommercialtranslation.types';
import { IItemCommercialTranslationData } from '@/models';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: IItemCommercialTranslationState = {
  version: 1,
  itemCommercialTranslations: [] as IItemCommercialTranslationData[],
  count: 0
};

const namespaced = true;

export const itemCommercialTranslation: Module<
  IItemCommercialTranslationState,
  IRootState
> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
